import { Pagination } from "@/js/modules/Pagination/Pagination";
import { Table } from "@/js/modules/Table/Table";
import React, { useCallback, useEffect } from "react";
import { NewTable } from "../../Table/NewTable";
// import { useNavigate } from 'react-router-dom'

const statuses = {
	in_process: {
		label: "В обработке",
		color: "orange",
	},
	active: {
		label: "Активная",
		color: "lightgreen",
	},
	inactive: {
		label: "Неактивная",
		color: "grey",
	},
	reject: {
		label: "Отклоненная",
		color: "red",
	},
};

export const TableSalePointsAll = props => {
	const { columns, statePoints, meta, onSend, isText, isClassMobile } = props;

	// const navigate = useNavigate()

	// const handleClick = useCallback((id) => {
	//   navigate(`/account/sale-point-edit/${id}`)
	// }, [])

	const tableDataNew = statePoints.context.list.map(item => ({
		id: item.id,
		name: item.name,
		owner: item.owner,
		entity_name: item.entity_name,
		region: item.region,
		seller:
			item.sellers?.length > 0 ? (
				<div>
					{item.sellers.map((seller, idx) => (
						<div key={idx}>
							{seller.name} {seller.surname}
							{/* {seller.status && (
								<span
									style={{ fontSize: "12px", marginLeft: "5px", color: "#666" }}
								>
									({seller.status.name})
								</span>
							)} */}
						</div>
					))}
				</div>
			) : (
				"—"
			),
		address: item.address,
		status: (
			<span style={{ color: statuses[item.status.slug]?.color ?? "black" }}>
				{item.status.i18n}
			</span>
		),
		// edit: <button onClick={() => handleClick(item.id)}>Редактировать</button>
	}));

	useEffect(() => {
		document.title = "Торговые точки | Программа лояльности SK ZIC";
	}, []);

	console.log("tableDataNew", tableDataNew);

	return (
		<div>
			{isText && (
				<p className="link_additional">
					Чтобы изменить реквизиты торговой точки, напишите нам через{" "}
					<a href="/feedback" target="_blank">
						обратную связь
					</a>
				</p>
			)}

			<NewTable
				headers={columns}
				overflow="auto"
				tableData={tableDataNew}
				isLoading={statePoints.matches("loading")}
			/>
			{/* <Table
				headers={columns}
				overflow="auto"
				tableData={tableDataNew}
				isLoading={statePoints.matches("loading")}
			/> */}
			{statePoints.context.list.length &&
			meta.lastPage > 1 &&
			!statePoints.matches("loading") ? (
				<Pagination
					pages={statePoints.context.pages}
					current_page={statePoints.context.current_page}
					send={onSend}
				/>
			) : (
				<></>
			)}
		</div>
	);
};
